import React from 'react';
import { VariableSizeList as List } from 'react-window';
import { useTheme, makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { safeEval } from './UtilFunctions';
import useCellMeasurer from './useCellMeasurer';

const MenuList = props => {
  const { children: passedChildren, customHeight } = props;
  const children = React.Children.toArray(passedChildren);
  const cellMeasurerProps = useCellMeasurer({ items: children });
  const getHeight = () => {
    const listHeight = children.length * 40;
    return listHeight > 300 ? 300 : listHeight;
  };
  return (
    <List
      width="100%"
      height={customHeight || getHeight()}
      {...cellMeasurerProps}
    >
      {({ index, style }) => {
        return <div style={style}>{children[index]}</div>;
      }}
    </List>
  );
};

const filterOptions = (candidate, input) => {
  if (input) {
    return safeEval(
      () => candidate.label.toLowerCase().includes(input.toLowerCase()),
      true,
    );
  }
  return true;
};

const OuterElementContext = React.createContext({});

const OuterElementType = React.forwardRef((props, ref) => {
  const outerProps = React.useContext(OuterElementContext);
  return <div ref={ref} {...props} {...outerProps} />;
});

function renderRow(props) {
  const { data, index, style } = props;
  return React.cloneElement(data[index], {
    style: {
      ...style,
      top: style.top + 8,
    },
  });
}

const ListboxComponent = React.forwardRef(function ListboxComponent(
  props,
  ref,
) {
  const { children, customHeight, ...other } = props;
  const itemData = React.Children.toArray(children);
  const itemCount = itemData.length;

  const cellMeasurerProps = useCellMeasurer({ items: children });
  const getHeight = () => {
    const listHeight = children.length * 40;
    return listHeight > 300 ? 300 : listHeight;
  };

  function useResetCache(data) {
    const reference = React.useRef(null);
    React.useEffect(() => {
      if (ref.current != null) {
        ref.current.resetAfterIndex(0, true);
      }
    }, [data]);
    return reference;
  }

  const gridRef = useResetCache(itemCount);

  return (
    <div ref={ref}>
      <OuterElementContext.Provider value={other}>
        <List
          itemData={itemData}
          height={getHeight() || customHeight}
          ref={gridRef}
          {...cellMeasurerProps}
          outerElementType={OuterElementType}
          innerElementType="ul"
          overscanCount={5}
          itemCount={itemCount}
        >
          {renderRow}
        </List>
      </OuterElementContext.Provider>
    </div>
  );
});

export { MenuList, filterOptions, ListboxComponent };
